import React, { Component } from 'react';
import withStyles from '@material-ui/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import Switch from '@material-ui/core/Switch';
import { InputLabel, TextField, Typography } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import axiosInstance, { API_URL } from '../common/Constants';
import axios from 'axios';
import cloneDeep from 'lodash/cloneDeep';
import swal from '@sweetalert/with-react';
import CircularProgress from '@material-ui/core/CircularProgress';

const styles = (theme) => ({
  bg: {
    width: '100%',
    overflowX: 'hidden',
    overflowY: 'auto',
    paddingTop: '20px',
    paddingLeft: '20px',
    paddingRight: '20px',
    '& .MuiInputBase-input': {
      fontFamily: 'SCDream',
    },
  },

  // 완료 도장 수정 시 적용
  // completedStampDiv: {
  //   position: 'absolute',
  //   left: '-15px',
  //   bottom: '-25px',
  //   width: '50%',
  //   height: 'auto',
  //   [theme.breakpoints.down('sm')]: {
  //     left: '-10px',
  //     bottom: '-20px',
  //   },
  // },
  // completedStamp: {
  //   width: '100%',
  //   [theme.breakpoints.down('sm')]: {
  //     // width: '40%',
  //   },
  // },
  titleTxt: {
    paddingBottom: 3,
    preView: '',
    fontSize: '20px',
    fontWeight: 700,
    [theme.breakpoints.down('xs')]: {
      fontSize: '14px',
    },
  },
  //modal
  entryPointModalContainer: {
    display: 'none',
    position: 'fixed' /* Stay in place */,
    zIndex: 1300 /* Sit on top */,
    left: 0,
    top: 0,
    width: '100vw' /* Full width */,
    height: '100%' /* Full height */,
    // height: '100vh' /* Full height */,
    overflowY: 'none' /* Enable scroll if needed */,
    //backgroundColor: 'rgb(0,0,0)' /* Fallback color */,
    backgroundColor: 'rgba(0,0,0,0.5)' /* Black w/ opacity */,
  },
  modalDiv: {
    width: '100%',
    height: '100%',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
  },
  entryPointModal: {
    display: 'flex',
    margin: '0 auto',
    width: 'calc(100% - 64px)',
    // height: '90%',
    maxWidth: '600px',
    maxHeight: 'calc(100% - 40px)',
    backgroundColor: '#fff',
    borderRadius: '4px',
    boxShadow: '0px 11px 15px -7px rgb(0 0 0 / 20%), 0px 24px 38px 3px rgb(0 0 0 / 14%), 0px 9px 46px 8px rgb(0 0 0 / 12%)',
  },
  modalCloseBtn: {
    width: 'calc(100% - 64px)',
    maxWidth: '600px',
    margin: '0 auto',
    display: 'flex',
    justifyContent: 'flex-end',
  },

  stampImg: {
    width: '200px',
    position: 'absolute',
    left: '60%',
    zIndex: '9999',
    top: '70%',
    opacity: '45%',
    transform: 'rotate(20deg)',
    [theme.breakpoints.down('md')]: {
      width: '30%',
      top: '75%',
      left: '70%',
    },
  },
  completedStamp: {
    position: 'absolute',
    left: '-15px',
    bottom: '-25px',
    [theme.breakpoints.down('sm')]: {
      width: '40%',
    },
  },

  reviewLabelDiv: {
    height: '27%',
    backgroundImage: `url('/images/mypage/entryPoint/reviewLabel.png')`,
    backgroundRepeat: 'no-repeat',
    backgroundSize: '150%',
    backgroundPosition: 'center center',
    // backgroundPosition: '100% 100%',
    // position: 'relative'
    [theme.breakpoints.down('xs')]: {
      height: '18%',
      backgroundSize: '165%',
    },
  },
  reviewLabelText: {
    // position: 'absolute',
    // top: '22%',
    // left: '50%',
    // transform: 'translateX(-50%)',
    height: '100%',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    fontSize: '1.2em',
    fontWeight: '700',
    color: '#fff',
    [theme.breakpoints.down('xs')]: {
      top: '18%',
      fontSize: '0.8em',
    },

    '& span': {
      paddingLeft: 7,
      fontSize: '0.8rem',
      [theme.breakpoints.down('xs')]: {
        paddingLeft: 2,
        fontSize: '0.5rem',
      },
    },
  },
});

const AntSwitch = withStyles((theme) => ({
  root: {
    width: 38,
    height: 20,
    padding: 0,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  switchBase: {
    padding: 2,
    color: '#FFFFFF',
    '&$checked': {
      transform: 'translateX(18px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.primary.main,
        borderColor: theme.palette.primary.main,
      },
    },
  },
  thumb: {
    width: 16,
    height: 16,
    boxShadow: 'none',
  },
  track: {
    border: `0px solid ${theme.palette.grey[500]}`,
    borderRadius: 18 / 2,
    opacity: 1,
    backgroundColor: '#E9E9E9',
  },
  checked: {},
}))(Switch);

class EntryPoint extends Component {
  constructor(props) {
    super(props);
    this.state = {
      allowBR: false,
      file: '',
      //previewURL: '',
      matches: window.matchMedia('(max-width:600px)').matches,
      mode: 0, // 0 : read , 1 : insert, 2 : modified, ? 3번은 잘  3: myRead 처음에는 0 이 였다가 데이터 들어오면 변경하는 로직
      refresh: false,
      bestReview: false,
      bestReviewComplete: false,
      isMe: false,
      showProgress: false,

      data: {
        content: '',
        course: { id: '', name: '' },
        id: '',
        img: '',
        isPublic: true,
        stamp: { id: '', name: '' },
      },
    };

    this.handleChange = this.handleChange.bind(this);
    this.refreshData = this.refreshData.bind(this);
  }

  modalClose = () => {
    let reset = {
      content: '',
      course: { id: '', name: '' },
      id: '',
      img: '',
      isPublic: true,
      stamp: { id: '', name: '' },
    };

    this.setState({ data: reset, bestReview: false, bestReviewComplete: false });

    document.getElementById('modalContainer').style.display = 'none';
    document.body.style.overflowY = 'inherit';
    if (
      navigator.userAgent.match(/mobile/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
    ) {
      document.body.style.overflow = 'inherit';
    }
    setTimeout(() => {
      this.props.onClose();
    }, 0);
  };

  modalOpen = () => {
    document.getElementById('modalContainer').style.display = 'block';
    document.body.style.overflowY = 'hidden';
    if (
      navigator.userAgent.match(/mobile/i) ||
      navigator.userAgent.match(/iPhone/i) ||
      navigator.userAgent.match(/iPod/i) ||
      navigator.userAgent.match(/iPad/i) ||
      navigator.userAgent.match(/^(safari|(?!chrome).)*$/gi)
    ) {
      document.body.style.overflow = 'hidden';
    }
  };

  refreshReview() {
    axiosInstance.get(`${API_URL}/review/info?reviewId=${this.props.reviewId}`, { headers: { Pragma: 'no-cache' } }).then((response) => {
      if (response.data) {
        this.setState({ data: response.data });
      }
    });
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.state.mode === 0) {
      if (this.props.reviewId) {
        if (this.state.refresh === true /* || (this.props.bestReview && this.state.bestReviewComplete === false)*/) {
          axiosInstance
            .get(`${API_URL}/review/info?reviewId=${this.props.reviewId}`, { headers: { Pragma: 'no-cache' } })
            .then((response) => {
              if (response.data.stamp.id === this.props.stampId) {
                if (response.data) {
                  console.log('here data');
                  console.log(response.data.user.id);
                  console.log('now me?');
                  console.log(localStorage.getItem(`loggedin`));
                  if (response.data.user.id === localStorage.getItem(`loggedin`)) {
                    this.setState({ data: response.data, refresh: false, isMe: true });
                  } else {
                    this.setState({ data: response.data, refresh: false, isMe: false });
                  }
                }
              } /* else if (this.props.bestReview) {
                if (response.data) {
                  this.setState({ data: response.data, refresh: false, bestReviewComplete: true });
                }
              }
              */
            });
        }
      }
    } else if (this.state.mode === 2) {
      if (this.state.refresh === true) {
        axiosInstance
          .get(`${API_URL}/review/infoByStampId?stampId=${this.props.stampId}&userId=${localStorage.getItem(`loggedin`)}`, {})
          .then((response) => {
            if (response.data) {
              this.setState({ data: response.data, refresh: false });
            }
          });
      }
    }
  }

  refreshData = (stampId) => {
    let loginId = localStorage.getItem(`loggedin`);
    //let currentId = localStorage.getItem(`loggedin`);

    axiosInstance
      .get(`${API_URL}/review/infoByStampId?stampId=${stampId}&userId=${loginId}`, { headers: { Pragma: 'no-cache' } })
      .then((response) => {
        if (response.data) {
          this.setState({ data: response.data });
        }
      });
  };

  handleChange(event, newValue) {
    this.setState({ value: newValue });
  }

  handleReviewText(event, newValue) {
    let buff = cloneDeep(this.state.data);
    buff.content = newValue.target.value;
    if (buff.content.length < 61) {
      this.setState({ data: buff });
    } else {
      swal({
        text: '리뷰 내용은 60자를 초과할 수 없습니다.',
        button: '확인',
      }).then(() => {
        buff.content = buff.content.substr(0, buff.content.length - 1);
        this.setState({ data: buff });
      });
    }
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let rtn = {};

    if (prevState.mode !== nextProps.mode) {
      if (rtn == null) {
        rtn = {};
      }

      console.log('nextProps.mode : ' + nextProps.mode);

      rtn['mode'] = nextProps.mode;
    }

    if (prevState.selectedReview !== nextProps.selectedReview) {
      if (rtn == null) {
        rtn = {};
      }

      if (nextProps.selectedReview) {
        rtn['data'] = nextProps.selectedReview;
      }
    }

    if (prevState.isQueryParam !== nextProps.isQueryParam && nextProps.isQueryParam && prevState.stampId !== nextProps.stampId) {
      if (nextProps.stampId) {
        //this.setState({ refresh: true });
        rtn['refresh'] = true;
        rtn['stampId'] = nextProps.stampId;
      }
    }

    if (prevState.isQueryParam !== nextProps.isQueryParam && nextProps.isQueryParam && prevState.reviewId !== nextProps.reviewId) {
      if (nextProps.reviewId) {
        rtn['refresh'] = true;
        rtn['reviewId'] = nextProps.reviewId;
      }
    }

    if (nextProps.courseInfo) {
      if (nextProps.courseInfo.stamp && nextProps.stampId) {
        let stampNameStr = '';
        let stampImg = '';
        for (let i = 0; i < nextProps.courseInfo.stamp.length; i++) {
          if (nextProps.courseInfo.stamp[i].id === nextProps.stampId) {
            stampNameStr = nextProps.courseInfo.stamp[i].name;
            stampImg = nextProps.courseInfo.stamp[i].img;
          }
        }
        rtn['stampName'] = stampNameStr;
        rtn['stampImg'] = stampImg;
      }
    }

    return rtn;
  }

  handleSwitch = (event) => {
    let buff = cloneDeep(this.state.data);
    buff.isPublic = event.target.checked;

    this.setState({
      data: buff,
    });
  };

  handleFileOnChange = (event) => {
    event.preventDefault();
    let reader = new FileReader();
    let file = event.target.files[0];
    reader.onloadend = () => {
      let buff = cloneDeep(this.state.data);
      buff.img = reader.result;

      this.setState({
        file: file,
        data: buff,
      });
    };
    reader.readAsDataURL(file);
  };

  deletedStamp = () => {
    swal({
      text: '리뷰내용을 삭제하시겠습니까?',
      buttons: {
        cancle: {
          text: '아니오',
          value: false,
        },
        confirm: {
          text: '네',
          value: true,
        },
      },
      closeOnClickOutside: false,
    }).then((isConfirm) => {
      if (isConfirm) {
        axiosInstance
          .delete(`${API_URL}/review/?reviewId=${this.state.data.id}`, {})
          .then((response) => {
            if (response.status === 200) {
              swal({
                text: '삭제가 완료되었습니다.',
                button: '확인',
              }).then(() => {
                this.modalClose();
              });
            }
          })
          .catch((err) => {
            console.log(err.response);
          });
      } else {
      }
    });
  };

  modifiedStamp = () => {
    swal({
      text: '리뷰내용을 수정하시겠습니까?',
      buttons: {
        cancle: {
          text: '아니오',
          value: false,
        },
        confirm: {
          text: '네',
          value: true,
        },
      },
      closeOnClickOutside: false,
    }).then((isConfirm) => {
      if (isConfirm) {
        let frm = new FormData();

        let file = document.getElementById('entry_point_image');
        if (file.files[0]) {
          frm.append('imgFile', file.files[0]);
        }
        frm.append('content', this.state.data.content);
        frm.append('user', localStorage.getItem(`loggedin`));
        frm.append('course', this.state.data.course.id);
        frm.append('stamp', this.state.data.stamp.id);
        frm.append('isPublic', this.state.data.isPublic);
        frm.append('reviewId', this.state.data.id);

        this.setState({ showProgress: true });

        axiosInstance
          .put(`${API_URL}/review/`, frm, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then((response) => {
            // console.log(response);
            this.setState({ showProgress: false });

            if (response.status === 200) {
              swal({
                text: '등록이 완료되었습니다.',
                button: '확인',
              }).then(() => {
                this.modalClose();
              });
            }
          })
          .catch((err) => {
            this.setState({ showProgress: false });
            console.log(err.response);
          });
      } else {
        // console.log('아니요');
      }
    });
  };

  postStamp = () => {
    let frm = new FormData();

    let file = document.getElementById('entry_point_image');
    frm.append('imgFile', file.files[0]);
    frm.append('content', this.state.data.content);
    frm.append('user', localStorage.getItem(`loggedin`));
    frm.append('course', this.props.courseId);
    frm.append('stamp', this.props.stampId);
    frm.append('isPublic', this.state.data.isPublic);
    //frm.append('isPublic', false);

    this.setState({ showProgress: true });

    axiosInstance
      .post(`${API_URL}/review/`, frm, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        // console.log(response);
        this.setState({ showProgress: false });

        if (response.status === 200) {
          swal({
            text: '등록이 완료되었습니다.',
            button: '확인',
          }).then(() => {
            //this.props.onClose();
            this.modalClose();
          });
        }
      })
      .catch((err) => {
        this.setState({ showProgress: false });
        console.log(err.response);
      });
  };

  /*
  snsLogin(type, res) {
    let param = null;
    if (type === 'kakao') {
      param = {
        sid: '' + res.profile.id,
        st: type,
        password: '' + res.profile.id,
        name: res.profile.kakao_account.profile.nickname,
        email: res.profile.kakao_account.email,
        img: res.profile.kakao_account.profile.profile_image_url || '',
        birthday: res.profile.kakao_account.birthday || '',
        gender: res.profile.kakao_account.gender || '',
        age_range: res.profile.kakao_account.age_range || '',
      };
    } else if (type === 'google') {
      param = {
        sid: '' + res.googleId,
        st: type,
        password: '' + res.googleId,
        name: res.profileObj.name || '',
        email: res.profileObj.email,
        img: res.profileObj.imageUrl || '',
      };
    } else if (type === 'naver') {
      param = {
        sid: '' + res.id,
        st: type,
        password: '' + res.id,
        name: res.name || '',
        email: res.email,
        phone: res.mobile || '',
      };
    }

    if (param) {
      axios
        .post(`${API_URL}/register`, param, { headers: { Pragma: 'no-cache' } })
        .then((response) => {
          this.doLogin(param.email, '' + param.password);
        })
        .catch((err) => {
          if (err.response && err.response.status === 308) {
            if (err.response.data.obj.st !== type) {
              // 다른 sns로 이미 가입한 사람
              swal('이미 가입하신 이메일주소입니다.').then(() => {
                window.opener = 'Self';
                window.open('', '_parent', '');
                window.close(); // 일반적인 현재 창 닫기
              });
            } else {
              this.doLogin(param.email, '' + param.password, type);
            }
          }
        });
    }
  }
  */

  checkLoginState = () => {
    console.log(window.FB);
    window.FB.getLoginStatus((response) => {
      console.log(response);
      if (response.status === 'connected') {
        axios
          .get(`https://graph.facebook.com/me?access_token=${window.FB.getAuthResponse()['accessToken']}`, {
            headers: { Pragma: 'no-cache' },
          })
          .then((response) => {
            // console.log(response.data.Items);
            console.log(response);

            let param = { message: 'aetateatataetaetafadfaf', access_token: window.FB.getAuthResponse()['accessToken'] };
            //if( response.data.id == "") {

            axios
              .post(`https://graph.facebook.com/me/feed`, param, {
                headers: { Pragma: 'no-cache' },
              })
              .then((response) => {
                // console.log(response.data.Items);
                console.log(response);
                //if( response.data.id == "") {

                //}
              })
              .catch((res) => {
                console.log(res);
              });

            //}

            /*
            axios
              .get(`https://graph.facebook.com/${response.data.id}/feed?access_token=${window.FB.getAuthResponse()['accessToken']}`, {
                headers: { Pragma: 'no-cache' },
              })
              .then((response) => {
                // console.log(response.data.Items);
                console.log(response);
                //if( response.data.id == "") {

                //}
              });

            //}
            */
          });
      } else {
        this.facebookLogin();
      }
    });
  };

  postFacebook = () => {
    let appId = '1071175723381381';

    let url = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=http%3A%2F%2F61.254.62.162%3A3000%2F%23%2FEntryPoint%2F1234&redirect_uri=https%3A%2F%2Fwww.facebook.com`;
    //let url = `https://www.facebook.com/dialog/share?app_id=${appId}&display=popup&href=http%3A%2F%2Fwww.naver.com&redirect_uri=https%3A%2F%2Fwww.facebook.com`;
    //window.location.href = url;
    window.open(url, '_blank');
  };

  postKakaoStory = () => {
    /*
    let param = {
      title: this.state.data.content,
      url: `http://www.doowon.net/#/mypage?review=${this.state.data.id}`,
      urlInfo: {
        images: [this.state.data.img],
      },
    };

    window.Kakao.Story.open(param);
    */

    /*
    let param = {};
    let token = '';
    axios
      .post(`https://kapi.kakao.com/v1/api/story/post/photo`, param, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        // console.log(response.data.Items);
        console.log(response);
        //if( response.data.id == "") {

        //}
      })
      .catch((res) => {
        console.log(res);
      });
    */
    //alert(this.state.data.id);

    //console.log(this.state.data.id);
    window.Kakao.Story.share({
      //url: 'http://www.doowon.net/point.html',
      //url: `http://www.doowon.net/#/mypage?review=${this.state.data.id}`,
      url: `${API_URL}/share/${this.state.data.id}`,
      text: '',
    });
  };

  postBand = () => {
    let buff1 = encodeURIComponent(`${this.state.data.content}\n${API_URL}/share/${this.state.data.id}`);
    let buff2 = encodeURIComponent(`${API_URL}/share/${this.state.data.id}`);
    window.open(`http://www.band.us/plugin/share?body=${buff1}&route=${buff2}`, 'share_band', 'width=410, height=540, resizable=no');
  };

  postWall = () => {
    let params = {
      message: 'FACEBOOK TEST',
      name: 'ttt',
      description: 'FB API',
      link: 'http://www.naver.com',
      access_token: window.FB.getAuthResponse()['accessToken'],
    };

    console.log(params);

    window.FB.api('/me/feed', 'post', params, (response) => {
      if (!response || response.error) {
        console.log(response);
      } else {
        alert('글등록 성공');
      }
    });
  };

  /*

"(#200) If posting to a group, requires app being installed in the group, and \
          either publish_to_groups permission with user token, or both pages_read_engagement \
          and pages_manage_posts permission with page token; If posting to a page, \
          requires both pages_read_engagement and pages_manage_posts as an admin with \
          sufficient administrative permission"
          */

  facebookLogin = () => {
    window.FB.login(
      function (response) {
        if (response.status === 'connected') {
        } else {
          console.log('Fail Login');
        }
      },
      /*
      {
        scope: '',
      },
      */
    );
  };

  render() {
    const {
      classes,
      courseInfo,
      //  selectedCourse,
      stampName,
    } = this.props;

    return (
      <div>
        <div
          id={'modalContainer'}
          className={classes.entryPointModalContainer}
          style={{ display: this.props.showDialog ? 'block' : 'none', overflowY: this.props.showDialog ? 'hidden' : 'inherit' }}
        >
          <div className={classes.modalDiv}>
            <div className={classes.modalCloseBtn}>
              <CloseIcon
                onClick={() => {
                  this.modalClose();
                }}
                style={{ color: '#fff', cursor: 'pointer', width: '1.5em', height: '1.5em' }}
                // style={{ position: 'absolute', right: '1em', top: '1em', cursor: 'pointer' }}
              />
            </div>
            <div className={classes.entryPointModal}>
              {/*
              <ReactHelmet
                keywords="성남누비길,남한산성남문"
                description="오늘 여기서 어쩌고 저쪼고 했음.."
                title="이것에 대한 타이틀"
                favicon="http://61.254.62.162:3000/assets/imgs/1.jpg"
              />
              */}
              <div className={classes.bg} style={{ height: this.state.mode === 0 ? 'auto' : 'auto', position: 'relative' }}>
                {/* 스탬프, 원래위치여기 */}
                {this.state.stampImg && (
                  <div
                    style={{
                      width: '200px',
                      height: '120px',
                      overflow: 'hidden',

                      position: 'absolute',
                      right: this.state.matches ? '40px' : '60px',
                      zIndex: '9999',
                      top: this.state.matches ? '110px' : '12%',
                    }}
                  >
                    <div
                      style={{
                        backgroundImage: `url('/images/mypage/entryPoint/reviewStampFrame2.png')`,
                        padding: '0px',
                        backgroundSize: '64%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: '100% center',
                        // backgroundPosition: '99% ​38%',
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        // right: 0,
                        width: '100%',
                        height: '100%',
                        overflow: 'hidden',
                      }}
                    >
                      <div
                        style={{
                          width: '86px',
                          position: 'absolute',
                          right: '21px',
                          zIndex: '9999',
                          top: '17px',
                          transform: 'rotate(6.5deg)',
                          height: '86px',
                          display: 'flex',
                          alignItems: 'center',
                        }}
                      >
                        <img
                          src={
                            /^\b(uploads\/.{1,})\b/gi.test(this.state.stampImg)
                              ? `http://61.254.62.162:4002/${this.state.stampImg}`
                              : this.state.stampImg
                          }
                          style={{ width: '100%', objectFit: 'cover', WebkitTouchCallout: 'none' /* height: '100%' */ }}
                          onContextMenu={(e) => e.preventDefault()}
                          alt={'img'}
                        ></img>
                      </div>
                    </div>
                  </div>
                )}
                <div style={{ padding: '0 3%', display: 'flex', flexDirection: 'column' }}>
                  {/* <Typography style={{ fontWeight: 'bold', padding: '10px 0 10px' }}>
              <span className={classes.titleTxt}>
                <span style={{ color: '#777' }}>
                  {courseInfo.name} {'> '}
                </span>
                <span style={{ color: '#555' }}>{selectedCourse.name}</span>
              </span>
              <CloseIcon
                onClick={() => this.props.onClose()}
                style={{ position: 'absolute', right: '1em', top: '1em', cursor: 'pointer' }}
              />
            </Typography> */}
                  <div style={{ width: '100%', display: 'flex', alignItems: 'center' }}>
                    <div style={{ padding: '10px 0 10px', width: 'calc(100%-100px)' }}>
                      <Typography style={{ fontWeight: 'bold' }}>
                        {this.state.mode === 1 ? (
                          // 추가 일때
                          <span className={classes.titleTxt}>
                            {/* 성남 누비길 {'>'} 남한산성 남문 */}
                            <span style={{ color: '#777', fontFamily: 'SCDream' }}>
                              {courseInfo && courseInfo.name ? courseInfo.name : ''}
                            </span>
                            {this.state.stampName ? (
                              <span style={{ color: '#555', fontFamily: 'SCDream' }}>{' > ' + this.state.stampName}</span>
                            ) : (
                              <span style={{ color: '#555', fontFamily: 'SCDream' }}>{' > ' + stampName}</span>
                            )}
                            {/* {stampName !== '' || typeof stampName !== undefined || !stampName ? (
                              <span style={{ color: '#555' }}>{' > ' + stampName}</span>
                            ) : (
                              <span style={{ color: '#555' }}>{' > ' + this.state.stampName}</span>
                            )} */}
                          </span>
                        ) : (
                          // 등록 수정 삭제 일때
                          <span className={classes.titleTxt}>
                            <span style={{ color: '#777', fontFamily: 'SCDream', minWidth: '50%' }}>
                              {this.state.data && this.state.data.course ? this.state.data.course.name : ''}
                            </span>
                            {this.state.data && this.state.data.stamp && (
                              <span style={{ color: '#555', fontFamily: 'SCDream' }}>{' > ' + this.state.data.stamp.name}</span>
                            )}
                          </span>
                        )}
                      </Typography>
                    </div>
                    <div style={{ flex: 1, minHeight: '60px' }}></div>
                    {this.state.mode === 2 || this.state.isMe ? (
                      <div style={{ width: '80px' }}>
                        {/* facebook 추가 시 상단 width 100으로 변경
                          <img src="./images/icon/ico_facebook.png" style={{ marginRight: '5px' }} />
                        */}
                        {/*
                        <img
                          alt="페이스북 공유"
                          src="/images/icon/ico_facebook.png"
                          style={{ marginRight: '5px', cursor: 'pointer' }}
                          onClick={() => {
                            this.postFacebook();
                          }}
                        />
                        */}
                        <img
                          alt="카카오스토리 공유"
                          src="/images/icon/ico_kakaostory.png"
                          style={{ marginRight: '5px', cursor: 'pointer' }}
                          onClick={() => {
                            this.postKakaoStory();
                          }}
                        />
                        <img
                          alt="네이버밴드 공유"
                          src="/images/icon/ico_band.png"
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            this.postBand();
                          }}
                        />
                      </div>
                    ) : (
                      <div></div>
                    )}
                    {/* <CloseIcon
                onClick={() => this.props.onClose()}
                style={{ position: 'absolute', right: '1em', top: '1em', cursor: 'pointer', zIndex: 9999 }}
              /> */}
                  </div>

                  <Grid container spacing={3} style={{ paddingBottom: '50px', paddingTop: '10px' }}>
                    <Grid item xs={12}>
                      <input
                        id="entry_point_image"
                        style={{ display: 'none', fontFamily: 'SCDream' }}
                        type="file"
                        accept="image/jpg,image/png,image/jpeg,image/gif"
                        name="profile_img"
                        onChange={this.handleFileOnChange}
                      ></input>

                      <div
                        onClick={() => {
                          if (this.state.mode !== 0) {
                            document.getElementById('entry_point_image').click();
                          }
                        }}
                        style={{
                          //height: this.state.matches ? '80vw' : '40vh',
                          height:
                            this.state.mode === 0 || (this.state.data && this.state.data.img)
                              ? 'auto'
                              : this.state.matches
                              ? '80vw'
                              : '40vh',
                          width: '100%',
                          background: this.state.mode === 0 || (this.state.data && this.state.data.img) ? '#fff' : '#ebebeb',
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center',
                          position: 'relative',
                          cursor: 'pointer',
                        }}
                      >
                        {this.state.mode === 0 || (this.state.data && this.state.data.img) ? null : (
                          <img src="./images/mypage/ic_profile_edit@3x.png" alt="프로필이미지" />
                        )}

                        {this.state.data && this.state.data.img ? (
                          <div style={{ position: 'relative', width: '100%', height: '0', overflow: 'hidden', paddingBottom: '126%' }}>
                            <div
                              style={{
                                backgroundImage: `url('/images/mypage/entryPoint/reviewImgFrame2.png')`,
                                // padding: this.state.matches ? '18px' : '36px',
                                // top: 0,
                                // left: 0,
                                // backgroundSize: 'contain',
                                backgroundSize: '98%',
                                backgroundRepeat: 'no-repeat',
                                backgroundPosition: '60% center',
                                position: 'absolute',
                                //
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                //
                                width: '100%',
                                height: '100%',
                                overflow: 'hidden',
                              }}
                            >
                              <img
                                alt="이미지없음"
                                className="profile_preview"
                                src={this.state.data.img}
                                style={{ width: '80%', height: '80%', objectFit: 'cover' /* width: '100%', height: '100%', */ }}
                              ></img>
                            </div>
                          </div>
                        ) : null}
                        {/*
                        this.state.stampImg && (
                          <img
                            src={this.state.stampImg}
                            class={classes.stampImg}
                            style={
                              {
                                // width: '200px',
                                // position: 'absolute',
                                // left: '70%',
                                // zIndex: '9999',
                                // top: '40%',
                                // opacity: '45%',
                                // transform: 'rotate(20deg)',
                              }
                            }
                            alt={'img'}
                          ></img>
                          
                          )*/}
                        {/* {selectedCourse && selectedCourse.isCompleted && (
                          // <div className={classes.completedStampDiv}>
                          //   <img src={`${API_URL}/${selectedCourse.img}`} alt="completedStamp" className={classes.completedStamp} />
                          // </div>
                          <img src={'images/mypage/completed_stamp@2x.png'} alt="completedStamp" className={classes.completedStamp} />
                        )} */}
                      </div>
                    </Grid>
                    <Grid item xs={12}>
                      <div className={classes.reviewLabelDiv} style={this.state.mode === 0 ? { marginBottom: '0.5em' } : {}}>
                        {/* <img src="/images/mypage/entryPoint/reviewLabel.png" style={{ width: '100%' }} /> */}
                        <div className={classes.reviewLabelText}>
                          REVIEW
                          {this.state.mode !== 0 && <span>({this.state.data.content.length} / 60)</span>}
                        </div>
                      </div>

                      <TextField
                        type="text"
                        value={this.state.data.content}
                        fullWidth={true}
                        variant="outlined"
                        multiline
                        // rowsMax={this.state.mode !== 1 ? 10 : 4}
                        maxRows={this.state.mode !== 1 ? 10 : 4}
                        minRows={4}
                        onChange={(event) => this.handleReviewText('name', event)}
                        InputProps={{
                          readOnly: this.state.mode === 0 ? true : false,
                        }}
                        style={{ fontFamily: 'SCDream' }}
                        fontFamily="SCDream"
                      />

                      {this.state.mode !== 0 ? (
                        <div
                          style={{
                            backgroundColor: '#fafafa',
                            borderRadius: '20px',
                            padding: '15px 30px',
                            marginTop: '20px',
                            display: 'flex',
                            flexDirection: 'rows',
                            alignItems: 'center',
                            height: '30px',
                          }}
                        >
                          <InputLabel
                            variant="standard"
                            filled
                            className={classes.InputLabel}
                            style={{ color: '#000', fontFamily: 'SCDream', fontWeight: this.state.matches ? '' : 'bold' }}
                          >
                            베스트 리뷰 공개 여부
                          </InputLabel>

                          <div style={{ flex: 1 }}></div>

                          <AntSwitch
                            checked={this.state.data.isPublic}
                            //checked={state.checkedA}
                            onChange={this.handleSwitch}
                          />

                          {/*
                  <ToggleButtonGroup value={this.state.allowBR} exclusive onChange={handleAllow}>
                    <ToggleButton value={true}>
                      <FormatAlignLeftIcon />
                    </ToggleButton>
                    <ToggleButton value={false}>
                      <FormatAlignCenterIcon />
                    </ToggleButton>
                  </ToggleButtonGroup>
                  */}
                        </div>
                      ) : null}
                    </Grid>
                  </Grid>

                  {/*
            <Grid container justify="center">
              <Button
                variant="contained"
                color="primary"
                style={{ width: '60%', padding: '15px', marginBottom: 100, color: '#fff', fontWeight: 'bold' }}
                onClick={() => {
                  this.postKakaoStory();
                  //this.checkLoginState();

                }}
              >
                카카오톡로그인
              </Button>

              <Button
                variant="contained"
                color="primary"
                style={{ width: '60%', padding: '15px', marginBottom: 100, color: '#fff', fontWeight: 'bold' }}
                onClick={() => {
                  this.postFacebook();
                }}
              >
                전송
              </Button>

              <Button
                variant="contained"
                color="primary"
                style={{ width: '60%', padding: '15px', marginBottom: 100, color: '#fff', fontWeight: 'bold' }}
                onClick={() => {
                  window.FB.api('/me/feed', 'post', { message: 'hi' }, function (response) {
                    console.log(response);
                  });
                }}
              ></Button>

              <Button
                variant="contained"
                color="primary"
                style={{ width: '60%', padding: '15px', marginBottom: 100, color: '#fff', fontWeight: 'bold' }}
                onClick={() => {
                  let buff1 = encodeURIComponent('http://www.naver.com');
                  let buff2 = encodeURIComponent('http://www.naver.com');
                  console.log(buff1);
                  console.log(buff2);
                  window.open(
                    `http://www.band.us/plugin/share?body=${buff1}&route=${buff2}`,
                    'share_band',
                    'width=410, height=540, resizable=no',
                  );
                }}
              >
                밴드
              </Button>
            </Grid>
            */}

                  {this.state.mode !== 0 ? (
                    <div
                      style={{
                        width: '100%',
                        height: '1px',
                        objectFit: 'contain',
                        boxShadow: '0px 10px 10px 0 rgba(0, 0, 0, 0.02)',
                        backgroundColor: '#f1f1f1',
                      }}
                    ></div>
                  ) : (
                    <div></div>
                  )}

                  {this.state.mode === 1 ? (
                    <div style={{ display: 'flex', flexDirection: 'rows', alignItems: 'center', justifyContent: 'center', height: '55px' }}>
                      <div
                        style={{ flex: '1', textAlign: 'center', padding: '10px', cursor: 'pointer', fontFamily: 'SCDream' }}
                        onClick={() => {
                          //this.props.onClose();
                          this.modalClose();
                          //this.props.onClose();
                          // this.props.history.replace('/mypage');
                        }}
                      >
                        {' '}
                        닫기{' '}
                      </div>{' '}
                      <div
                        style={{
                          width: '1px',
                          height: '15px',
                          opacity: '0.1',
                          backgroundColor: '#555555',
                        }}
                      ></div>
                      <div
                        onClick={() => {
                          /*
                    alert('게시가 완료되었습니다.');
                    this.props.onClose();
                    */
                          // this.props.history.replace('/mypage');

                          this.postStamp();
                        }}
                        style={{
                          flex: '1',
                          textAlign: 'center',
                          color: '#ca502b',
                          padding: '10px',
                          cursor: 'pointer',
                          fontFamily: 'SCDream',
                        }}
                      >
                        게시하기
                      </div>
                    </div>
                  ) : this.state.mode === 2 ? (
                    <div style={{ display: 'flex', flexDirection: 'rows', alignItems: 'center', justifyContent: 'center', height: '55px' }}>
                      <div
                        style={{
                          flex: '1',
                          textAlign: 'center',
                          padding: '10px',
                          color: '#ca502b',
                          cursor: 'pointer',
                          fontFamily: 'SCDream',
                          fontWeight: this.state.matches ? '' : 'bold',
                        }}
                        onClick={() => {
                          this.modifiedStamp();

                          //console.log('CLOSE');
                          //this.props.onClose();
                          // this.props.history.replace('/mypage');
                        }}
                      >
                        {' '}
                        게시물수정{' '}
                      </div>{' '}
                      <div
                        style={{
                          width: '1px',
                          height: '15px',
                          opacity: '0.1',
                          backgroundColor: '#555555',
                        }}
                      ></div>
                      <div
                        onClick={() => {
                          this.deletedStamp();
                          //alert('게시가 완료되었습니다.');

                          //this.props.onClose();
                          // this.props.history.replace('/mypage');
                        }}
                        style={{
                          flex: '1',
                          textAlign: 'center',
                          padding: '10px',
                          cursor: 'pointer',
                          fontFamily: 'SCDream',
                          fontWeight: this.state.matches ? '' : 'bold',
                        }}
                      >
                        게시물삭제
                      </div>
                    </div>
                  ) : (
                    <div></div>
                  )}
                </div>
              </div>
            </div>
            {this.state.showProgress ? (
              <div
                style={{
                  width: '100%',
                  height: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  position: 'absolute',
                  left: 0,
                  top: 0,
                  backgroundColor: 'rgba( 0, 0, 0, 0.5 )',
                }}
              >
                <CircularProgress color="secondary" />
              </div>
            ) : null}
          </div>
        </div>
      </div>
    );
  }
}
export default withStyles(styles, { withTheme: true })(EntryPoint);
//withRoute 할때와의 차이?
